import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './search-bar-component.html',
  styleUrls: ['./search-bar-component.css']
})
export class SearchBarComponent {
  @Input() placeholder: string = 'Search';
  @Output() search = new EventEmitter<string>();

  searchText: string = '';

  clear(): void {
    this.searchText = '';
    this.search.emit('');
  }

  onInput(): void {
    this.search.emit(this.searchText);
  }
}
